import { render, staticRenderFns } from "./softLi.vue?vue&type=template&id=a3245824&scoped=true"
import script from "./softLi.vue?vue&type=script&lang=js"
export * from "./softLi.vue?vue&type=script&lang=js"
import style0 from "./softLi.vue?vue&type=style&index=0&id=a3245824&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3245824",
  null
  
)

export default component.exports